<template>
  <v-dialog v-model="dialog_ref" max-width="768" persistent>
    <v-card>
      <v-card-title class="text-h5 justify-center accent white--text">
        {{ editMode == true ? "Editar" : "Guardar" }} cotización&nbsp;
        <v-icon class="white--text">{{
          editMode == true ? "mdi-pencil" : "mdi-content-save"
        }}</v-icon>
        <v-spacer></v-spacer>
        <v-btn icon outlined @click="emitCancel" class="white--text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <h6 class="mt-4 text-h6">
          {{
            editMode == true
              ? "¿Desea proceder con el editado de esta cotización?"
              : "¿Desea proceder con el guardado de esta cotización?"
          }}
        </h6>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel">
          <v-icon>mdi-cancel</v-icon>&nbsp;Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="accent" @click="editMode == true ? edit() : save()">
          <v-icon>mdi-check-circle-outline</v-icon>&nbsp; Confirmar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { httpPost, httpPut, httpDelete } from "@/services/apiService";
export default {
  props: {
    dialog_ref: Boolean,
    editMode: Boolean,
  },
  computed: {
    current() {
      return this.$store.state.current ?? null;
    },
    selected() {
      return this.$store.state.selected ?? [];
    },
    selectedServices() {
      return this.$store.state.services.selectedServices ?? [];
    },
    selectedClient() {
      return this.$store.state.client.selectedClient ?? null;
    },
    selectedDestiny() {
      return this.$store.state.destinies.selectedDestiny ?? null;
    },
    name() {
      return this.$store.state.client.name ?? null;
    },
    email() {
      return this.$store.state.client.email ?? null;
    },
    phone() {
      return this.$store.state.client.phone ?? null;
    },
    pago() {
      return this.$store.state.pago ?? null;
    },
    fabricacion() {
      return this.$store.state.fabricacion ?? null;
    },
    entrega() {
      return this.$store.state.entrega ?? null;
    },
    observaciones() {
      return this.$store.state.observaciones ?? null;
    },
    subtotal() {
      return this.$store.state.subtotal ?? null;
    },
    iva() {
      return this.$store.state.iva ?? null;
    },
    total() {
      return this.$store.state.total ?? null;
    },
    pesoTotal() {
      return this.$store.state.pesoTotal ?? null;
    },
  },
  methods: {
    emitCancel() {
      this.$emit("onCancel");
    },
    emitConfirm() {
      this.$emit("onConfirm");
    },
    async save() {
      const body = {
        productos: this.selected,
        servicios: this.selectedServices,
        subtotal: this.subtotal,
        iva: this.iva,
        total: this.total,
        peso_total: this.pesoTotal,
        fecha_elaboracion: new Date().toISOString(),
        vendedor: JSON.parse(sessionStorage.getItem("user"))["id"],
        cliente: this.selectedClient != null ? this.selectedClient?.id : null,
        nombre_cliente: this.name,
        clave_cliente:
          this.selectedClient != null ? this.selectedClient.attributes.clave : null,
        correo_cliente: this.email,
        telefono_cliente: this.phone,
        pago: this.pago,
        fabricacion: this.fabricacion,
        entrega: this.entrega,
        observaciones: this.observaciones,
        persona_recibe: null,
        telefono_recibe: null,
        destino: this.selectedDestiny,
      };

      // Save quotation data.
      const { data } = await httpPost("/cotizaciones", { data: body }).catch(
        (error) => {
          ("error saving quotation", error);
          this.$toasted.show(
            "No fue posible guardar la cotización. Intente de nuevo más tarde.",
            {
              type: "error",
            }
          );
          return;
        }
      );

      // Create folio with quotation data and name;
      const name = JSON.parse(sessionStorage.getItem("user"))[
        "nombre_completo"
      ];
      const folio = this.getFolio(name, data?.data?.id);

      // Update quotation witn folio
      const { data: edit } = await httpPut("/cotizaciones/" + data?.data?.id, {
        data: { folio },
      }).catch(async (editError) => {
        ("error saving folio, rolling back...", editError);
        await httpDelete("/cotizaciones/" + data?.data?.id);
        this.$toasted.show(
          "No fue posible foliar la cotización. Intente de nuevo más tarde.",
          {
            type: "error",
          }
        );
        return;
      });
      ("data", edit?.data);
      this.$store.commit("setCurrent", edit?.data);
      this.$store.dispatch("validate");
      this.$toasted.show("Cotización guardada correctamente", {
        type: "success",
      });
      this.emitConfirm();
    },
    async edit() {
      const body = {
        productos: this.selected,
        servicios: this.selectedServices,
        subtotal: this.subtotal,
        iva: this.iva,
        total: this.total,
        peso_total: this.pesoTotal,
        correo_cliente: this.email,
        telefono_cliente: this.phone,
        pago: this.pago,
        fabricacion: this.fabricacion,
        entrega: this.entrega,
        observaciones: this.observaciones,
        persona_recibe: this.current?.attributes?.persona_recibe,
        telefono_recibe: this.current?.attributes?.telefono_recibe,
      };

      const { data } = await httpPut("/cotizaciones/" + this.current?.id, {
        data: body,
      }).catch((error) => {
        ("error saving quotation", error);
        this.$toasted.show(
          "No fue posible guardar la cotización. Intente de nuevo más tarde.",
          {
            type: "error",
          }
        );
        return;
      });

      this.$toasted.show("Cotización editada", {
        type: "success",
      });
      this.emitConfirm();
    },
    getFolio(str, quoteID) {
      let matches = str.match(/\b(\w)/g);
      let acronym = matches.join("");
      let id = quoteID < 10 ? `0${quoteID}` : String(quoteID);
      return `${acronym}-${id}`;
    },
  },
};
</script>